import { createFileRoute, redirect } from '@tanstack/react-router';
import { PlanTypeParam } from 'utils/billing';

export const Route = createFileRoute('/n/_auth/settings/_layout/billing/edit-plan/_tabs/')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/settings/billing/edit-plan/$planType',
      params: { planType: PlanTypeParam.Managed },
      replace: true,
    });
  },
});
